<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card class="p-4 mb-6">
        <div class="flex flex-wrap items-center justify-between mb-10">
            <div class="flex items-center">
                <h4 style="margin-left: 10px">POD</h4>
            </div>
            <div class="flex items-center">
                <vs-button
                    class="mb-4 mr-1 btn md:mb-0"
                    @click="refreshData"
                    icon="refresh"
                >Refresh</vs-button>
                <vs-button :to="{ name: 'pod-view', params: {id: selectedId} }" class="mb-4 mr-1 md:mb-0" icon="remove_red_eye" :disabled="selectedId ? false : true">View</vs-button>
                <vs-button
                    class="mb-4 mr-1 md:mb-0"
                    icon="filter_list"
                    @click="filterInit"
                >Filter</vs-button>
                <vs-button
                    class="mb-4 mr-1 md:mb-0"
                    icon="import_export"
                    @click="exportExcel({ endpoint: 'transport/pod/export', filter: filter, name: 'export_report_pod' })"
                >Export</vs-button>
                <vs-button
                    class="mb-4 mr-1 md:mb-0"
                    icon="import_export"
                    @click="filterGetPod"
                >Get POD</vs-button>
            </div>
        </div>
        <ag-grid-vue
            :gridOptions="gridOptions"
            class="my-4 ag-theme-material w-100 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="manifest"
            colResizeDefault="shift"
            :animateRows="false"
            :floatingFilter="false"
            rowSelection="single"
            @selection-changed="onSelectionChanged"
            @rowDoubleClicked="viewData"
            >
        </ag-grid-vue>
        <p class="text-right"><b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }}  total entries</b></p>
        <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
        <!-- start-filter -->
        <vs-prompt @accept="fetchData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <vs-input v-model="filter.manifest_id" class="w-full mb-2" label="Manifest ID" />

                <label class="vs-input--label">Schedule Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr class="w-full p-2 vx-col" v-model="filter.schedule_date_start" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">To</vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr class="w-full p-2 vx-col" v-model="filter.schedule_date_end" />
                    </vs-col>
                </vs-row>

                <label class="vs-input--label">Vehicle ID</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.vehicle_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_vehicle)"
                >
                    <vs-select-item v-for="(item, index) in ddl_vehicle.data" :key="index" :value="item.id" :text="item.vehicle_code"/>
                </vs-select>

                <label class="vs-input--label">Status POD</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.pod_code_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_podcodes)"
                >
                    <vs-select-item v-for="(item, index) in ddl_podcodes.data" :key="index" :value="item.id" :text="item.pod_code"/>
                </vs-select>

                <label class="vs-input--label">Transporter ID</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.transporter_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_transporter)"
                >
                    <vs-select-item v-for="(item, index) in ddl_transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                </vs-select>

                <label class="vs-input--label">Origin ID</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.origin_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_origin)"
                >
                    <vs-select-item v-for="(item, index) in ddl_origin.data" :key="index" :value="item.id" :text="item.village"/>
                </vs-select>

                <label class="vs-input--label">Destination ID</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.destination_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_destination)"
                >
                    <vs-select-item v-for="(item, index) in ddl_destination.data" :key="index" :value="item.id" :text="item.village"/>
                </vs-select>

            </div>
        </vs-prompt>

        <vs-prompt @accept="getDataPod" title="Get POD" :active.sync="showGetPod">
            <div class="con-exemple-prompt">

                <label class="vs-input--label">POD Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12" style="padding-left: 0">
                        <flat-pickr class="w-full p-2 vx-col" v-model="filter_get_pod.date" />
                    </vs-col>
                </vs-row>

            </div>
        </vs-prompt>
    <!-- end-filter -->
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import { saveAs } from "file-saver";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
    },
    data() {
        return {
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            isLoading: false,
            maxRetry: 10,
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            manifest: [],
            filter: {
                manifest_id: "",
                client_id: null,
                schedule_date_start: null,
                schedule_date_end: null,
                transporter_id: null,
                origin_id: null,
                destination_id: null,
                vehicle_id:null,
            },
            selectedId: null,
            showFilter: false,
            ddl_client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            ddl_transporter: {
                data: [],
                loading: false,
                endpoint: 'master/transporters',
                objectKey: 'transporter_code'
            },
            ddl_vehicle: {
                data: [],
                loading: false,
                endpoint: 'master/vehicle',
                objectKey: 'vehicle_code'
            },
            ddl_podcodes: {
                data: [],
                loading: false,
                endpoint: 'master/podcodes',
                objectKey: 'pod_code'
            },
            ddl_origin: {
                data: [],
                loading: false,
                endpoint: 'master/areas',
                objectKey: 'name'
            },
            ddl_destination: {
                data: [],
                loading: false,
                endpoint: 'master/areas',
                objectKey: 'name'
            },
            ddl_customer: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            filter_get_pod: {
                date: null,
            },
            showGetPod: false,
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
        currentPage() {
            this.fetchData()
        },
    },
    methods: {
        fetchData() {
            this.isLoading = true
            this.setFilter(this.filter);

            Promise.all([this.$http.post('transport/pod?page=' + this.currentPage, this.filter), this.$http.post('unlock_all')])
            .then(this.$http.spread((resp, unlock) => {
                this.manifest = resp.data.data
                this.totalPage = resp.data.last_page;
                this.dataTotal = resp.data.total;
                this.dataFrom = resp.data.from;
                this.dataTo = resp.data.to;
                this.isLoading = false
            }))
            .catch(resp => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.refreshData()
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
                return;
            })
        },
        viewData() {
            this.$router.push({
                name: 'pod-view',
                params: {
                    id: this.selectedId
                }
            })
        },
        refreshData() {
            this.maxRetry = 10
            this.fetchData()
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
            console.log(this.selectedId);
        },
        filterInit() {
            if(!this.masterSync){

                this.$http.all([
                this.$http.post("master/customers"),
                this.$http.post('master/clients'),
                this.$http.post("master/areas"),
                this.$http.post("master/transporters"),
                this.$http.post("master/vehicle"),
                this.$http.post("master/warehouses"),
                this.$http.post("master/vehicletypes"),
                this.$http.post("master/podcodes"),
                this.$http.post("master/contracttypes"),
                this.$http.post("master/transportersmode"),
                ])
                .then(
                    this.$http.spread(
                        (
                    customer,
                    clients,
                    areas,
                    transporters,
                    vehicles,
                    warehouses,
                    vehicletypes,
                    podcodes,
                    contracttypes,
                    mode,
                    ) => {
                        // this.areaOptions = [];
                        this.ddl_origin.data = areas.data.data;
                        this.ddl_destination.data = areas.data.data;
                        this.ddl_client.data = clients.data.data;
                        this.ddl_transporter = transporters.data;
                        this.ddl_vehicle.data = vehicles.data.data;
                        this.ddl_podcodes.data = podcodes.data.data;

                        this.ddl_origin.data.unshift({
                            id: null,
                            name: 'Any'
                        })
                        this.ddl_destination.data.unshift({
                            id: null,
                            name: 'Any'
                        })
                        this.ddl_client.data.unshift({
                            id: null,
                            client_code: 'Any'
                        })
                        this.ddl_transporter.data.unshift({
                            id: null,
                            transporter_code: 'Any'
                        })
                        this.ddl_vehicle.data.unshift({
                            id: null,
                            vehicle_code: 'Any'
                        })
                        this.ddl_podcodes.data.unshift({
                            id: null,
                            pod_code: 'Any'
                        })
                        this.masterSync = true ;
                        setTimeout(() => {
                            this.showFilter = true;
                        }, 500);
                    }
                )
                )
                .catch((error) => {
                    this.isLoading = false;
                    this.masterSync = false ;
                    console.log(error)
                });
            }else{
                setTimeout(() => {
                    this.showFilter = true;
                }, 500);
            }
        },
        filterGetPod() {
            this.showGetPod = true;
        },
        getDataPod() {
            this.isLoading = true

            this.$http.post('transport/routeplanning/update_courier_pod_status', this.filter_get_pod ).then((resp) => {
                console.log(resp);
                this.isLoading = false

                this.fetchData();
            })
            .catch((resp) =>{
                console.log(resp.response);
                this.isLoading = false

                this.$vs.notify({
                    color: "danger",
                    title: "POD",
                    text: "Get POD Failed"
                });
            });
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.fetchData()
    },
    beforeMount() {
        const filter = this.getFilter();

        if(filter) {
            this.filter = filter
            this.filter.fetchCount = 0;
        }

        this.columnDefs = [
            {
                headerName: 'Manifest ID',
                field: 'id',
                width: 120,
                filter: true,
            },
            {
                headerName: 'Schedule Date',
                field: 'schedule_date',
                width: 120,
                filter: true,
            },
            {
                headerName: 'Origin',
                field: 'origin.village',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Destination',
                field: 'destination.village',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Driver',
                field: 'vehicle.driver',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Vehicle Type',
                field: 'vehicle_type.vehicle_type',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Police Number',
                field: 'vehicle.vehicle_code',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Tranporter',
                field: 'transporter.name',
                filter: true,
                width: 120,
            },
        ];

        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
}

</script>
